import { center } from "@turf/turf";
import maplibregl from "maplibre-gl";
import { generatedMapStyleJSON } from "../components/layers/variables/layerStylingValues";
import { cssHelper } from "../utils/helpers";
import { mergeGeoJSONData } from "../utils/mergeFloorData";
const defaultBackgroundStyle = { url: "", options: { display: "none" } };
const defaultContentStyle = { url: "", options: { display: "none" } };
// const defaultPoiStyle: null = null;
const defaultMinZoomConstant = 0;
const defaultMaxZoomConstant = 0;
export default class GeoJSONEditor {
    // private _markersAlreadyInitialized = false;
    constructor(map, cuEventer, regExRoomLabel) {
        this._buildingMarkers = [];
        this._addressMarkers = [];
        this._poiMarkers = [];
        this._showOnlyAddressMarkers = false;
        this._showAddressMarkersAndBuildingMarkers = false;
        this._setupMarker = () => {
            if (this._buildingMarkers.length) {
                this._buildingMarkers.forEach((m) => m.element.remove());
                this._buildingMarkers = [];
            }
            if (this._addressMarkers.length) {
                this._addressMarkers.forEach((m) => m.element.remove());
                this._addressMarkers = [];
            }
            if (this._poiMarkers.length) {
                this._poiMarkers.forEach((m) => m.element.remove());
                this._poiMarkers = [];
            }
        };
        this.setSavePoiMarker = (poiNodes) => {
            this._poiNodes = poiNodes;
        };
        this.setSaveAddressMarker = (addressNodes) => {
            this._addressNodes = addressNodes;
        };
        this.setShowAddressMarkersAndBuildingMarkers = (value) => {
            this._showAddressMarkersAndBuildingMarkers = value;
        };
        this.setShowOnlyAddressMarker = (value) => {
            this._showOnlyAddressMarkers = value;
        };
        this.initPoiMarker = () => {
            var _a, _b;
            let mapStyleJson = undefined;
            let markerNodes = undefined;
            let finalMarkers = undefined;
            mapStyleJson = generatedMapStyleJSON === null || generatedMapStyleJSON === void 0 ? void 0 : generatedMapStyleJSON.pois;
            if (mapStyleJson == null || mapStyleJson.iconJsonB64 == null)
                return;
            markerNodes = this._poiNodes;
            finalMarkers = this._poiMarkers;
            let defaultMaxZoom = null;
            let defaultMinZoom = null;
            // Müssne gmergt werden
            const poiStyleMapMerged = new Map();
            const iconJsonFaIconJsonStyleIdMap = new Map();
            mapStyleJson.iconJsonFaIconJson.forEach((element) => {
                if (element.value.url != null &&
                    element.value.url != "" &&
                    element.value.options != null &&
                    Object.keys(element.value.options).length !== 0) {
                    iconJsonFaIconJsonStyleIdMap.set(element.styleId, element.value.options);
                }
            });
            [...mapStyleJson.iconJsonB64, ...mapStyleJson.iconJsonFa].forEach((element) => {
                if (poiStyleMapMerged.has(element.styleId)) {
                    const oldObject = poiStyleMapMerged.get(element.styleId);
                    if (oldObject.value.url == "" && element.value.url != "") {
                        const newObject = {
                            ...oldObject,
                            value: {
                                ...element.value,
                            },
                        };
                        poiStyleMapMerged.set(element.styleId, newObject);
                    }
                }
                else {
                    poiStyleMapMerged.set(element.styleId, element);
                }
            });
            const showOnAllLevelsStyleIds = [];
            if (mapStyleJson.showOnAllLevels !== undefined) {
                mapStyleJson.showOnAllLevels.forEach((entry) => {
                    if (entry.value === true) {
                        showOnAllLevelsStyleIds.push(entry.styleId);
                    }
                });
            }
            const labelMaxZoomMap = (_a = mapStyleJson === null || mapStyleJson === void 0 ? void 0 : mapStyleJson.labelMaxZoom) === null || _a === void 0 ? void 0 : _a.reduce((map, obj) => {
                if (obj.default === true) {
                    defaultMaxZoom = obj.value;
                }
                return map.set(obj.styleId, obj.value);
            }, new Map());
            const labelMinZoomMap = (_b = mapStyleJson === null || mapStyleJson === void 0 ? void 0 : mapStyleJson.labelMinZoom) === null || _b === void 0 ? void 0 : _b.reduce((map, obj) => {
                if (obj.default === true) {
                    defaultMinZoom = obj.value;
                }
                return map.set(obj.styleId, obj.value);
            }, new Map());
            const currentZoom = this._map.getZoom();
            const currentLevel = this._map.currentLevel;
            markerNodes === null || markerNodes === void 0 ? void 0 : markerNodes.forEach((b) => {
                var _a, _b, _c;
                let myStyleId = null;
                if (this._map.cuDataManager.loadUnpublishedGidData) {
                    myStyleId = (_a = this._map.cuDataManager._gidStyleMap) === null || _a === void 0 ? void 0 : _a.get((_b = b.properties.globalPoiId) !== null && _b !== void 0 ? _b : b.properties.globalId);
                }
                else {
                    myStyleId = (_c = b.properties.styleClasses) === null || _c === void 0 ? void 0 : _c.published;
                }
                let labelElement;
                let imageElement;
                let divElement;
                let currentBackgroundContent = (poiStyleMapMerged === null || poiStyleMapMerged === void 0 ? void 0 : poiStyleMapMerged.has(myStyleId))
                    ? poiStyleMapMerged.get(myStyleId)
                    : null;
                let currentIconContent = (iconJsonFaIconJsonStyleIdMap === null || iconJsonFaIconJsonStyleIdMap === void 0 ? void 0 : iconJsonFaIconJsonStyleIdMap.has(myStyleId))
                    ? iconJsonFaIconJsonStyleIdMap.get(myStyleId)
                    : null;
                let currentMinZoom = (labelMinZoomMap === null || labelMinZoomMap === void 0 ? void 0 : labelMinZoomMap.has(myStyleId))
                    ? labelMinZoomMap.get(myStyleId)
                    : defaultMinZoom !== null && defaultMinZoom !== void 0 ? defaultMinZoom : defaultMinZoomConstant;
                let currentMaxZoom = (labelMaxZoomMap === null || labelMaxZoomMap === void 0 ? void 0 : labelMaxZoomMap.has(myStyleId))
                    ? labelMaxZoomMap.get(myStyleId)
                    : defaultMaxZoom !== null && defaultMaxZoom !== void 0 ? defaultMaxZoom : defaultMaxZoomConstant;
                if (currentBackgroundContent != undefined &&
                    currentBackgroundContent.value.url.startsWith("data") &&
                    !currentIconContent) {
                    divElement = document.createElement("div");
                    divElement.setAttribute("instituteGlobalId", b.properties.instituteGlobalId);
                    imageElement = document.createElement("img");
                    imageElement.setAttribute("instituteGlobalId", b.properties.instituteGlobalId);
                    imageElement.alt = b.properties.name;
                    imageElement.src = currentBackgroundContent.value.url;
                    cssHelper(imageElement, currentBackgroundContent.value.options);
                    imageElement.style["border-radius"] = "50%";
                    divElement.appendChild(imageElement);
                    labelElement = divElement;
                }
                else if (currentBackgroundContent != undefined && currentIconContent) {
                    divElement = document.createElement("div");
                    divElement.setAttribute("instituteGlobalId", b.properties.instituteGlobalId);
                    imageElement = document.createElement("img");
                    imageElement.setAttribute("instituteGlobalId", b.properties.instituteGlobalId);
                    imageElement.alt = b.properties.name;
                    imageElement.src = currentBackgroundContent.value.url;
                    cssHelper(imageElement, currentIconContent);
                    cssHelper(divElement, currentBackgroundContent.value.options);
                    divElement.style["display"] = "flex";
                    imageElement.style["margin"] = "auto";
                    divElement.appendChild(imageElement);
                    labelElement = divElement;
                }
                if (labelElement != null) {
                    const showOnAllLeves = showOnAllLevelsStyleIds.includes(myStyleId);
                    const polygonCenter = center(b);
                    const here = {
                        lng: polygonCenter.geometry.coordinates[0],
                        lat: polygonCenter.geometry.coordinates[1],
                    };
                    const myMarker = new maplibregl.Marker(labelElement).setLngLat(here);
                    labelElement.addEventListener("click", (e) => {
                        if (this._map.setLevelState != null) {
                            e.stopPropagation();
                            this._cuEventer.fireEvent("poiClick", b);
                            this._map.setLevelState(b.properties.level);
                        }
                    });
                    const finalMarker = {
                        minZoom: currentMinZoom,
                        maxZoom: currentMaxZoom,
                        element: myMarker,
                        level: b.properties.level,
                        showOnAllLevels: showOnAllLeves,
                    };
                    if (currentZoom < currentMaxZoom && currentZoom >= currentMinZoom) {
                        if (currentLevel === finalMarker.level) {
                            this.toggleMarker(finalMarker, true);
                        }
                    }
                    finalMarkers.push(finalMarker);
                }
            });
        };
        this.initMarker = (markerType) => {
            var _a, _b, _c, _d;
            let mapStyleJson = undefined;
            let markerNodes = undefined;
            let finalMarkers = undefined;
            let nameFunction = undefined;
            const hideAddressLabelStyleIds = [];
            if (markerType === "building") {
                mapStyleJson = generatedMapStyleJSON === null || generatedMapStyleJSON === void 0 ? void 0 : generatedMapStyleJSON.buildings;
                markerNodes = this._uniqueBuildingLabelsFiltered;
                nameFunction = (node) => {
                    return node.properties.name;
                };
                finalMarkers = this._buildingMarkers;
            }
            else if (markerType === "address") {
                mapStyleJson = generatedMapStyleJSON === null || generatedMapStyleJSON === void 0 ? void 0 : generatedMapStyleJSON.address;
                markerNodes = this._addressNodes;
                // console.log(
                //   "Hide addresslabel mapstyle",
                //   generatedMapStyleJSON?.address.hideAddressLabel
                // );
                if ((generatedMapStyleJSON === null || generatedMapStyleJSON === void 0 ? void 0 : generatedMapStyleJSON.address.hideAddressLabel) !== undefined) {
                    generatedMapStyleJSON === null || generatedMapStyleJSON === void 0 ? void 0 : generatedMapStyleJSON.address.hideAddressLabel.forEach((entry) => {
                        if (entry.value === true) {
                            hideAddressLabelStyleIds.push(entry.styleId);
                        }
                    });
                }
                finalMarkers = this._addressMarkers;
                nameFunction = (node) => {
                    return node.properties.short;
                };
            }
            else {
                return;
            }
            let defaultFoundContent = null;
            let defaultFoundBackground = null;
            let defaultMaxZoom = null;
            let defaultMinZoom = null;
            // console.log("Current MapSstyleJSON", mapStyleJson);
            const labelBackgroundsMap = (_a = mapStyleJson === null || mapStyleJson === void 0 ? void 0 : mapStyleJson.labelBackgrounds) === null || _a === void 0 ? void 0 : _a.reduce((map, obj) => {
                if (obj.default === true) {
                    defaultFoundBackground = obj.value;
                }
                return map.set(obj.styleId, obj.value);
            }, new Map());
            const labelContentMap = (_b = mapStyleJson === null || mapStyleJson === void 0 ? void 0 : mapStyleJson.labelContent) === null || _b === void 0 ? void 0 : _b.reduce((map, obj) => {
                if (obj.default === true) {
                    defaultFoundContent = obj.value;
                }
                return map.set(obj.styleId, obj.value);
            }, new Map());
            const labelMaxZoomMap = (_c = mapStyleJson === null || mapStyleJson === void 0 ? void 0 : mapStyleJson.labelMaxZoom) === null || _c === void 0 ? void 0 : _c.reduce((map, obj) => {
                if (obj.default === true) {
                    defaultMaxZoom = obj.value;
                }
                return map.set(obj.styleId, obj.value);
            }, new Map());
            const labelMinZoomMap = (_d = mapStyleJson === null || mapStyleJson === void 0 ? void 0 : mapStyleJson.labelMinZoom) === null || _d === void 0 ? void 0 : _d.reduce((map, obj) => {
                if (obj.default === true) {
                    defaultMinZoom = obj.value;
                }
                return map.set(obj.styleId, obj.value);
            }, new Map());
            // console.log("Current labelContentMap", labelContentMap, markerType);
            // console.log("Current labelBackgroundMap", labelBackgroundsMap, markerType);
            // console.log("Current labelMaxZoomMap", labelMaxZoomMap, markerType);
            // console.log("Current labelMinZoomMap", labelMinZoomMap, markerType);
            // console.log(
            //   "Type",
            //   markerType,
            //   "Found Defaults: Content",
            //   defaultFoundContent,
            //   "Background",
            //   defaultFoundBackground,
            //   "minZoom",
            //   defaultMinZoom,
            //   "maxZoom",
            //   defaultMaxZoom
            // );
            // Potentielle Rennkondition
            // console.log("Current gidStyleMap", this._map.cuDataManager._gidStyleMap);
            // console.log("Markers", markerNodes);
            const currentZoom = this._map.getZoom();
            // console.log("current Zoom", currentZoom);
            markerNodes === null || markerNodes === void 0 ? void 0 : markerNodes.forEach((b) => {
                var _a, _b, _c;
                let myName = nameFunction(b);
                let myStyleId = null;
                if (this._map.cuDataManager.loadUnpublishedGidData) {
                    myStyleId = (_a = this._map.cuDataManager._gidStyleMap) === null || _a === void 0 ? void 0 : _a.get((_b = b.properties.globalPoiId) !== null && _b !== void 0 ? _b : b.properties.globalId);
                }
                else {
                    myStyleId = (_c = b.properties.styleClasses) === null || _c === void 0 ? void 0 : _c.published;
                }
                if (hideAddressLabelStyleIds.includes(myStyleId)) {
                    return;
                }
                let labelElement;
                let imageElement;
                let divElement;
                let currentContent = (labelContentMap === null || labelContentMap === void 0 ? void 0 : labelContentMap.has(myStyleId))
                    ? labelContentMap.get(myStyleId)
                    : defaultFoundContent !== null && defaultFoundContent !== void 0 ? defaultFoundContent : defaultContentStyle;
                let currentBackground = (labelBackgroundsMap === null || labelBackgroundsMap === void 0 ? void 0 : labelBackgroundsMap.has(myStyleId))
                    ? labelBackgroundsMap.get(myStyleId)
                    : defaultFoundBackground !== null && defaultFoundBackground !== void 0 ? defaultFoundBackground : defaultBackgroundStyle;
                let currentMinZoom = (labelMinZoomMap === null || labelMinZoomMap === void 0 ? void 0 : labelMinZoomMap.has(myStyleId))
                    ? labelMinZoomMap.get(myStyleId)
                    : defaultMinZoom !== null && defaultMinZoom !== void 0 ? defaultMinZoom : defaultMinZoomConstant;
                let currentMaxZoom = (labelMaxZoomMap === null || labelMaxZoomMap === void 0 ? void 0 : labelMaxZoomMap.has(myStyleId))
                    ? labelMaxZoomMap.get(myStyleId)
                    : defaultMaxZoom !== null && defaultMaxZoom !== void 0 ? defaultMaxZoom : defaultMaxZoomConstant;
                if (currentBackground.url != undefined && currentBackground.url != "") {
                    imageElement = document.createElement("img");
                    imageElement.alt = b.properties.name;
                    imageElement.src = currentContent.url;
                    labelElement = imageElement;
                }
                else if (myName != null) {
                    divElement = document.createElement("div");
                    if (currentBackground.options != null) {
                        cssHelper(divElement, currentBackground.options);
                    }
                    let icon;
                    let text;
                    let innerContent;
                    if (currentContent.url != null && currentContent.url != "") {
                        icon = document.createElement("img");
                        icon.alt = b.properties.name;
                        icon.src = currentContent.url;
                        innerContent = icon;
                    }
                    else {
                        text = document.createElement("span");
                        text.innerHTML = nameFunction(b);
                        innerContent = text;
                    }
                    cssHelper(innerContent, currentContent.options);
                    divElement.appendChild(innerContent);
                    labelElement = divElement;
                }
                if (labelElement != null) {
                    const polygonCenter = center(b);
                    const here = {
                        lng: polygonCenter.geometry.coordinates[0],
                        lat: polygonCenter.geometry.coordinates[1],
                    };
                    const myMarker = new maplibregl.Marker(labelElement).setLngLat(here);
                    const finalMarker = {
                        minZoom: currentMinZoom,
                        maxZoom: currentMaxZoom,
                        element: myMarker,
                    };
                    if (currentZoom < currentMaxZoom && currentZoom >= currentMinZoom) {
                        // myMarker.addTo(this._map);
                        this.toggleMarker(finalMarker, true);
                    }
                    finalMarkers.push(finalMarker);
                }
            });
        };
        this.markerZoomHandler = (currentZoomLevel) => {
            var _a;
            const currentLevel = (_a = this._map) === null || _a === void 0 ? void 0 : _a.currentLevel;
            this._poiMarkers.forEach((marker) => {
                let markerIsOnCurrentLevel = marker.level != null && marker.level == currentLevel;
                let markerIsVisibleInDependencyOfZoomLevelMyFriendILikeLongVariableNamesHashtagYolo = marker.minZoom <= currentZoomLevel && marker.maxZoom > currentZoomLevel;
                if (markerIsVisibleInDependencyOfZoomLevelMyFriendILikeLongVariableNamesHashtagYolo) {
                    if (marker.showOnAllLevels) {
                        if (!markerIsOnCurrentLevel) {
                            this.toggleMarkerOpacity(marker, true, 0.5);
                        }
                        else {
                            this.toggleMarkerOpacity(marker, true, 1.0);
                        }
                    }
                    else {
                        if (!markerIsOnCurrentLevel) {
                            this.toggleMarkerOpacity(marker, false, 0.0);
                        }
                        else {
                            this.toggleMarkerOpacity(marker, true, 1.0);
                        }
                    }
                    // this.toggleMarker(marker, true);
                }
                else {
                    this.toggleMarker(marker, false);
                }
            });
            this._buildingMarkers.forEach((marker) => {
                if (marker.minZoom <= currentZoomLevel &&
                    marker.maxZoom > currentZoomLevel) {
                    this.toggleMarker(marker, true);
                }
                else {
                    this.toggleMarker(marker, false);
                }
            });
            this._addressMarkers.forEach((marker) => {
                if (marker.minZoom <= currentZoomLevel &&
                    marker.maxZoom > currentZoomLevel) {
                    this.toggleMarker(marker, true);
                }
                else {
                    this.toggleMarker(marker, false);
                }
            });
        };
        this._map = map;
        this._cuEventer = cuEventer;
        this._regExRoomLabel = regExRoomLabel;
    }
    toggleMarkerOpacity(marker, enable, opacity) {
        if (enable) {
            marker.element.getElement().style["transition"] = "opacity 1s";
            marker.element.getElement().style["opacity"] = "" + opacity;
            marker.element.addTo(this._map);
        }
        else {
            marker.element.getElement().style["transition"] = "opacity 1s";
            marker.element.getElement().style["opacity"] = "0";
            marker.element.getElement().addEventListener("transitionend", () => {
                marker.element.remove();
            });
        }
    }
    toggleMarker(marker, enable) {
        if (enable) {
            marker.element.getElement().style["transition"] = "";
            marker.element.getElement().style["opacity"] = "1";
            marker.element.addTo(this._map);
        }
        else {
            marker.element.getElement().style["transition"] = "opacity 1s";
            marker.element.getElement().style["opacity"] = "0";
            marker.element.getElement().addEventListener("transitionend", () => {
                marker.element.remove();
            });
        }
    }
    toggleAllMarker(enable) {
        this._poiMarkers.forEach((marker) => {
            if (enable) {
                this.toggleMarker(marker, true);
            }
            else {
                this.toggleMarker(marker, false);
            }
        });
        this._buildingMarkers.forEach((marker) => {
            if (enable) {
                this.toggleMarker(marker, true);
            }
            else {
                this.toggleMarker(marker, false);
            }
        });
        this._addressMarkers.forEach((marker) => {
            if (enable) {
                this.toggleMarker(marker, true);
            }
            else {
                this.toggleMarker(marker, false);
            }
        });
    }
    addTemporaryFloorData(floorData, campusKey) {
        if (campusKey == null) {
            campusKey =
                this._map.cuDataManager.campusCollection.getCurrentCampus().campusKey;
        }
        // push to added
        this._map.getGeoJSONCollection().temporary[campusKey] = floorData;
        // combine
        const combinedCollection = mergeGeoJSONData([
            this._map.getGeoJSONCollection().temporary[campusKey],
            this._map.getGeoJSONCollection().added[campusKey],
        ]);
        // setData on the temporary layer
        this.setFloorData(combinedCollection, "temporary");
    }
    /**
     * Push the temporary FloorData to permanently added data (not saved to the cloud, only for this session).
     * If you again add floorData it will not overwrite you previously added data.
     */
    confirmTemporaryFloorData() {
        // combine added with temporary
        const added = this._map.getGeoJSONCollection().added;
        const temporary = this._map.getGeoJSONCollection().temporary;
        // use campusKeys from temporary
        for (const [campusKey, temporaryCollection] of Object.entries(temporary)) {
            // look for already added collection with the correspondant campusKey
            const addedCollection = added[campusKey];
            if (addedCollection) {
                // if a addedCollection with the correspondant campusKey exists -> merge added and temporary
                added[campusKey] = mergeGeoJSONData([
                    addedCollection,
                    temporaryCollection,
                ]);
            }
            else {
                // if it doesn't exist yet, just assign the temporary to it
                added[campusKey] = temporaryCollection;
            }
        }
        try {
            // finally add them to the map
            const campusKey = this._map.campusCollection.getCurrentCampus().campusKey;
            const combinedCollection = mergeGeoJSONData([
                this._map.getGeoJSONCollection().fetched[campusKey],
                this._map.getGeoJSONCollection().added[campusKey],
            ]);
            this.setFloorData(combinedCollection);
        }
        catch (e) {
            console.error("There has been an error trying to set the floorData when confirming", e);
        }
        // setData on the temporary layer
        this.resetTemporaryFloorData();
    }
    resetTemporaryFloorData() {
        this._map.getGeoJSONCollection().temporary = {};
        this.setFloorData({ floors: [], ground: [], outlines: [], rooms: [] }, "temporary");
    }
    /**
     * Specifically sets features for the main indoor layers. If given null | undefined, nothing will happen, if you give an empty array [] or
     * a feature collection with an empty "features" array
     * @param geoJSONData
     */
    setFloorData(geoJSONData, type = "permanent") {
        const _set = () => {
            var _a, _b;
            try {
                const indoorSources = type === "permanent"
                    ? this._map.cuSourceIds.indoorGeoJSONs
                    : this._map.cuSourceIds_temporary.indoorGeoJSONs;
                const outdoorSources = type === "permanent"
                    ? {
                        polygons: this._map.cuSourceIds.buildingGeoJSONs.common,
                        labels: this._map.cuSourceIds.buildingsLabels.common,
                        persistent: this._map.cuSourceIds.buildingGeoJSONs.persistent,
                    }
                    : {
                        polygons: this._map.cuSourceIds_temporary.buildingGeoJSONs.common,
                        labels: this._map.cuSourceIds_temporary.buildingsLabels.common,
                        persistent: this._map.cuSourceIds_temporary.buildingGeoJSONs.persistent,
                    };
                if (geoJSONData.ground != null) {
                    this._map.setFeatures(indoorSources.ground, geoJSONData.ground);
                }
                const hideBuildingsLabelStyleIds = [];
                const buildingLabelsFiltered = [];
                const hideBuildingLabel = generatedMapStyleJSON === null || generatedMapStyleJSON === void 0 ? void 0 : generatedMapStyleJSON.buildings.hideBuildingLabel;
                if (hideBuildingLabel !== undefined) {
                    hideBuildingLabel.forEach((entry) => {
                        if (entry.value === true) {
                            hideBuildingsLabelStyleIds.push(entry.styleId);
                        }
                    });
                }
                // @ts-ignore
                (_a = geoJSONData.buildings) === null || _a === void 0 ? void 0 : _a.forEach((b) => {
                    if (!hideBuildingsLabelStyleIds.includes(b.properties.styleId)) {
                        buildingLabelsFiltered.push(b);
                    }
                });
                this._uniqueBuildingLabelsFiltered = [
                    ...new Set(buildingLabelsFiltered),
                ];
                this._setupMarker();
                if (this._showOnlyAddressMarkers === true) {
                    this.initMarker("address");
                    console.log("Only using address markers");
                }
                else if (this._showAddressMarkersAndBuildingMarkers) {
                    this.initMarker("address");
                    this.initMarker("building");
                }
                else {
                    this.initMarker("building");
                }
                this.initPoiMarker();
                if (geoJSONData.buildings != null) {
                    let filteredPersistentBuildings = [];
                    let filteredNonPersistentBuildings = [];
                    // @ts-ignore
                    (_b = geoJSONData.buildings) === null || _b === void 0 ? void 0 : _b.forEach((building) => {
                        if (building.properties.hasContent === false) {
                            filteredPersistentBuildings.push(building);
                        }
                        else {
                            filteredNonPersistentBuildings.push(building);
                        }
                    });
                    // console.log(
                    //   "this is my builidng geojson collect",
                    //   filteredNonPersistentBuildings
                    // );
                    this._map.setFeatures(outdoorSources.polygons, filteredNonPersistentBuildings);
                    this._map.setFeatures(outdoorSources.persistent, filteredPersistentBuildings);
                }
                if (geoJSONData.masks != null) {
                    this._map.setFeatures(this._map.cuSourceIds.maskingGeoJSONs.common, geoJSONData.masks);
                }
                if (geoJSONData.outlines != null) {
                    this._map.setFeatures(indoorSources.outline, geoJSONData.outlines);
                }
                if (geoJSONData.rooms != null) {
                    let roomFeatures = geoJSONData.rooms;
                    if ("features" in geoJSONData.rooms) {
                        roomFeatures = geoJSONData.rooms.features;
                    }
                    else {
                        roomFeatures = geoJSONData.rooms;
                    }
                    try {
                        const levelFilteredRooms = [];
                        const glassFilteredRooms = [];
                        const labelsFilteredRooms = [];
                        // -- prefilter by level --
                        // to make mapbox filtering more performant it's necessary
                        // to prefilter rooms, so while the user is moving/zooming on one level
                        // mapbox don't need to iterate 30k room features
                        // the same with glassRooms
                        const glassRoomMapStyle = generatedMapStyleJSON === null || generatedMapStyleJSON === void 0 ? void 0 : generatedMapStyleJSON.rooms.glass.filter((entry) => {
                            return entry.value === true;
                        });
                        const glassRoomStyleIds = glassRoomMapStyle === null || glassRoomMapStyle === void 0 ? void 0 : glassRoomMapStyle.map((entry) => {
                            return entry.styleId;
                        });
                        // console.log("My passed regex", this._regExRoomLabel);
                        const uuidRegex = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/;
                        roomFeatures.forEach((r) => {
                            var _a, _b;
                            if (r.properties.level === this._map.currentLevel) {
                                if (this._regExRoomLabel != null && r.properties.name) {
                                    let res = r.properties.name.match(this._regExRoomLabel);
                                    if (res != null && res.length > 0) {
                                        const transformedRoom = {
                                            ...r,
                                            properties: {
                                                ...r.properties,
                                                short: res[0],
                                            },
                                        };
                                        labelsFilteredRooms.push(transformedRoom);
                                    }
                                }
                                else {
                                    if (r.properties.name.match(uuidRegex)) {
                                        const transformedRoom = {
                                            ...r,
                                            properties: {
                                                ...r.properties,
                                                short: "",
                                                name: "",
                                            },
                                        };
                                        labelsFilteredRooms.push(transformedRoom);
                                    }
                                    else {
                                        labelsFilteredRooms.push(r);
                                    }
                                }
                                levelFilteredRooms.push(r);
                                if (((_a = r.properties) === null || _a === void 0 ? void 0 : _a.styleId) &&
                                    (glassRoomStyleIds === null || glassRoomStyleIds === void 0 ? void 0 : glassRoomStyleIds.includes((_b = r.properties) === null || _b === void 0 ? void 0 : _b.styleId))) {
                                    r.properties.glass = true;
                                }
                                if (r.properties.glass) {
                                    glassFilteredRooms.push(r);
                                }
                            }
                        });
                        // console.log("All my rooms with name", labelsFilteredRooms);
                        this._map.setFeatures(indoorSources.rooms, levelFilteredRooms);
                        this._map.setFeatures(indoorSources.glassRooms, glassFilteredRooms);
                        // Wir setzen jetzt hier die Source. Es ist wohl eine andere Source als bisher.
                        // Aber vorher wurde sicher auch eine Source gesetzt. Das kommt jetzt raus.
                        this._map.setFeatures(indoorSources.roomsLabel, labelsFilteredRooms);
                    }
                    catch (e) {
                        this._map.setFeatures(indoorSources.rooms, roomFeatures);
                        this._map.setFeatures(indoorSources.glassRooms, roomFeatures);
                        console.warn("Could not prefilter by level geoojsons", e);
                    }
                }
            }
            catch (e) {
                this._cuEventer.fireEvent("geoJSONError");
                console.error("Something went wrong when updating floor layers", geoJSONData, e);
            }
        };
        if (this._map.cuMapLoaded) {
            _set();
        }
        else {
            const loadTimeout = setInterval(() => {
                if (this._map.cuMapLoaded) {
                    _set();
                    clearInterval(loadTimeout);
                }
            }, 50);
        }
    }
}
